import { combineReducers } from 'redux';

import email from './email';
import isSending from './isSending';

export default combineReducers({
  email,
  isSending,
});
